import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const role = getCurrentRole();
  const token = role === "super_admin" ? localStorage.getItem("sa_token") : localStorage.getItem("token");
  if (token) cfg.headers["Authorization"] = `Bearer ${token}`;
  const pin = localStorage.getItem("edit_pin");
  if (pin) cfg.headers["X-Edit-Pin"] = pin;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // token expired
    }
    return Promise.reject(err);
  }
);

export function saveSession({ token, role, firm_name, firm_id }) {
  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  if (firm_name) localStorage.setItem("firm_name", firm_name);
  if (firm_id) localStorage.setItem("firm_id", firm_id);
}
export function clearSession() {
  ["token", "role", "firm_name", "firm_id", "edit_pin", "firm_token", "firm_token_name", "sa_token", "company_id", "company_name", "companies_json"].forEach(
    (k) => localStorage.removeItem(k)
  );
}
export function getCurrentRole() {
  return localStorage.getItem("role");
}
export function fmtINR(n) {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
export function todayISO() {
  return new Date().toISOString();
}

export default client;
